import { useState } from 'react';
import I18n from 'I18n';
import { DownIcon, UpIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import { TruncateMultiline } from 'foundations-components/transitional/components/TruncateMultiline';
import { Flex } from 'foundations-components/components/Flex';
import { useMediaQuery } from '../../utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACInstructorCard = ({
  imageUrl,
  name,
  description,
  jobTitle,
  maxInlineSize,
  minInlineSize,
  organisationName,
  organisationUrl,
  onClick
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpand = () => setIsExpanded(prevFlag => !prevFlag);
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "500",
    maxInlineSize: maxInlineSize,
    minInlineSize: minInlineSize,
    onClick: handleExpand,
    children: [/*#__PURE__*/_jsxs(Media, {
      align: "center",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(Image, {
          alt: I18n.text('academyCommon.instructor.imageAlt', {
            instructorName: name
          }),
          height: 60,
          loading: "lazy",
          objectFit: "cover",
          responsive: false,
          shape: "rounded",
          src: imageUrl,
          width: 60
        })
      }), /*#__PURE__*/_jsxs(MediaBody, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: isMobile ? 'h7' : 'h4',
          marginBlockEnd: "0",
          children: name
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: jobTitle
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: organisationUrl && organisationName ? /*#__PURE__*/_jsx(Link, {
            external: true,
            href: organisationUrl,
            onClick: onClick,
            children: organisationName
          }) : organisationName
        })]
      }), isMobile && /*#__PURE__*/_jsx(MediaRight, {
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "end",
          children: isExpanded ? /*#__PURE__*/_jsx(UpIcon, {}) : /*#__PURE__*/_jsx(DownIcon, {})
        })
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: !isMobile || isExpanded,
      children: /*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockEnd: "0",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(TruncateMultiline, {
          maxChars: 500,
          text: description || ''
        })
      })
    })]
  });
};
export default ACInstructorCard;